import { PropsWithChildren } from 'react'

import Head from 'next/head'

interface Props {
  name?: string
  description?: string
  append?: boolean
  favicon?: string
}

export const PageHead = ({
  append = true,
  children,
  description,
  name,
  favicon,
}: PropsWithChildren<Props>): JSX.Element => {
  const appName = 'Your App'
  const pageName = () => {
    if (append) {
      return name ? `${name} | ${appName}` : appName
    }
    return name ?? appName
  }
  const pageDesc = description ?? appName
  return (
    <Head>
      <meta charSet="utf-8" />
      <title>{pageName()}</title>
      <meta content={pageDesc} name="description" />
      <meta content={pageName()} name="og:title" />
      <meta content={pageDesc} name="og:description" />
      <link href={favicon} rel="shortcut icon" />
      {children}
    </Head>
  )
}
